import styled from 'styled-components';

const AtlasContainer = styled.div`
  margin-left: -10px;
  position: absolute;
  width: 100%;
  height: calc(100% - 60px);
`;

export default {
  AtlasContainer
};
